import React, { useContext, useState } from 'react'
import { LanguageContext } from '../Language/LanguageContext'
import { Row, Col, Form, Button } from 'react-bootstrap'
import { Container, NotifyContext, Loading } from '../Library'
import { changePassword } from '../Network/Authentication'
import "./ChangePassword.css"
import { useHistory } from 'react-router-dom'

function ChangePassword() {
    const langCx = useContext(LanguageContext)
    const notify = useContext(NotifyContext)
    const lang = langCx.lang.change_password
    const history = useHistory()
    
    const [isLoading, setLoading] = useState(false)
    const [isError, setIsError] = useState(false)
    const [error, setError] = useState("")
    const [oldPassword, setOldPassword] = useState("")
    const [newPassword, setNewPassword] = useState("")
    const [confirmPassword, setConfirmPassword] = useState("")

    const onSubmit = () =>{
        if(!oldPassword || !newPassword || !confirmPassword){
            setIsError(true)
            notify.showNotify(lang.not_complete, lang.not_complete_desc, 1)
            return;
        }

        setLoading(true)
        changePassword(oldPassword, newPassword, confirmPassword,
            ()=>{
                notify.showNotify(lang.change_success, lang.change_success_desc, 0)
                setLoading(false)
                history.goBack()
            },
            (error)=>{
                setLoading(false)
                if(error.response !== undefined){
                    let passwordError = error.response.data.message
                    if(passwordError === "Wrong password."){
                        setError(lang.wrong_password)
                    }else if(passwordError === "Password is not match."){
                        setError(lang.not_match)
                    }else if(passwordError === "Password must be 6 - 32 alphanumeric characters."){
                        setError(lang.at_least)
                    }else if(passwordError === "Password is same previous."){
                        setError(lang.same_previous)
                    }else{
                        setError(passwordError)
                    }
                }else{
                    notify.showNotify("Something wrong", error.message, 2)
                }
            })
    }

    return (
        <Container topbarTitle={lang.change_password}>
            { isLoading ? <Loading/> : null }
            <Row>
                <Col lg={8}>
                    <div className="desc-password">{lang.change_password_desc}</div>
                    <Form
                    onSubmit={(e)=>{
                        e.preventDefault()
                        onSubmit()
                    }}>
                        <Form.Group>
                            <Form.Label>{lang.old_password}</Form.Label>
                            <Form.Control
                            type="password"
                            isInvalid={isError && !oldPassword}
                            value={oldPassword}
                            onChange={(e)=>setOldPassword(e.target.value)}
                            />
                        </Form.Group>
                        <Form.Group>
                            <Form.Label>{lang.new_password}</Form.Label>
                            <Form.Control
                            type="password"
                            isInvalid={isError && !newPassword}
                            value={newPassword}
                            onChange={(e)=>setNewPassword(e.target.value)}
                            />
                        </Form.Group>
                        <Form.Group>
                            <Form.Label>{lang.confirm_password}</Form.Label>
                            <Form.Control
                            type="password"
                            isInvalid={isError && !confirmPassword}
                            value={confirmPassword}
                            onChange={(e)=>setConfirmPassword(e.target.value)}
                            />
                        </Form.Group>
                        { error !== "" ?
                        <div className="error-text">
                            {error}
                        </div> : null
                        }
                        <hr style={{marginTop: 30}}/>
                        <Button type="submit">
                            {lang.change_password}
                        </Button>
                    </Form>
                </Col>
            </Row>
        </Container>
    )
}

export default ChangePassword
